var e={NUMBER:"num",BOOLEAN:"bool",STRING:"str",DATE:"date"};export{e as a};
